/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_Roll_Up_3Inputs */

const en_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const fr_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défilement 3`)
};

const de_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const it_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const ru_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const es_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const zh_cn2_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const ja_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールアップ3`)
};

const hi_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोल-अप 3`)
};

const pt_pt2_caption_style_roll_up_3 = /** @type {(inputs: Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrole 3`)
};

/**
* | output |
* | --- |
* | "Roll-Up 3" |
*
* @param {Caption_Style_Roll_Up_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_roll_up_3 = /** @type {((inputs?: Caption_Style_Roll_Up_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_Roll_Up_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style_roll_up_3(inputs)
	if (locale === "de") return de_caption_style_roll_up_3(inputs)
	if (locale === "it") return it_caption_style_roll_up_3(inputs)
	if (locale === "ru") return ru_caption_style_roll_up_3(inputs)
	if (locale === "es") return es_caption_style_roll_up_3(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style_roll_up_3(inputs)
	if (locale === "ja") return ja_caption_style_roll_up_3(inputs)
	if (locale === "hi") return hi_caption_style_roll_up_3(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style_roll_up_3(inputs)
	return en_caption_style_roll_up_3(inputs)
});